<template>
  <div class="agent-page">
    <div class="page-header">
      <h2 class="page-title">招标文件详情</h2>
      <el-button type="primary" icon="el-icon-back" @click="handleBack">返回</el-button>
    </div>
    <div class="content-wrap">
      <!-- 基本信息 -->
      <div class="section-block">
        <div class="section-title">基本信息</div>
        <el-row :gutter="20" class="detail-row">
          <el-col :span="12">
            <div class="field">
              <span class="label">招标文件编号：</span>
              <span class="value">{{ detailData.bidInvitationDocumentsCode || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">招标文件名称：</span>
              <span class="value">{{ detailData.bidInvitationDocumentsName || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">文件类型：</span>
              <span class="value">{{ getDocumentTypeText(detailData.documentType) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">文件编制状态：</span>
              <span class="value">{{ getDocumentStatusText(detailData.documentPreparationStatus) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">开标时间：</span>
              <span class="value">{{ detailData.bidOpeningTime || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">解密截止时间：</span>
              <span class="value">{{ detailData.decryptionDeadline || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">创建时间：</span>
              <span class="value">{{ detailData.createTime || '-' }}</span>
            </div>
          </el-col>
           <el-col :span="12">
            <div class="field">
              <span class="label">质疑提出截止时间：</span>
              <span class="value">{{ detailData.bidSectionConfig.questionDeadline || '-' }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 标段信息列表 -->
      <div class="section-block" v-if="detailData.bidSectionList && detailData.bidSectionList.length > 0">
        <div class="section-title">标段信息</div>
        <el-table :data="detailData.bidSectionList" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="标段编号" prop="bidSectionCode" min-width="180"></el-table-column>
          <el-table-column label="标段名称" prop="bidSectionName" min-width="300"></el-table-column>
        </el-table>
      </div>

      <!-- 招标文件正文 -->
      <div class="section-block" v-if="mainFileList.length > 0">
        <div class="section-title">
          <i class="el-icon-document"></i> 招标文件正文
          <el-tag size="mini" type="info" style="margin-left:8px;">{{ mainFileList.length }} 份</el-tag>
        </div>
        <el-table :data="mainFileList" border stripe size="small">
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column label="文件名称" prop="fileName" min-width="260" show-overflow-tooltip></el-table-column>
          <el-table-column label="格式" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.fileExtension === 'pdf' ? 'danger' : 'primary'">
                {{ (scope.row.fileExtension || '-').toUpperCase() }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="文件大小" width="110" align="center">
            <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDownloadFile(scope.row)">
                <i class="el-icon-download"></i> 下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 附件 -->
      <div class="section-block" v-if="attFileList.length > 0">
        <div class="section-title">
          <i class="el-icon-paperclip"></i> 附件
          <el-tag size="mini" type="info" style="margin-left:8px;">{{ attFileList.length }} 份</el-tag>
        </div>
        <el-table :data="attFileList" border stripe size="small">
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column label="文件名称" prop="fileName" min-width="260" show-overflow-tooltip></el-table-column>
          <el-table-column label="格式" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini"
                :type="scope.row.fileExtension === 'pdf' ? 'danger' : ['doc','docx'].includes(scope.row.fileExtension) ? 'primary' : 'warning'">
                {{ (scope.row.fileExtension || '-').toUpperCase() }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="文件大小" width="110" align="center">
            <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDownloadFile(scope.row)">
                <i class="el-icon-download"></i> 下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 开标一览表 -->
      <div class="section-block" v-if="openingListEnvelope1.length > 0 || openingListEnvelope2.length > 0">
        <div class="section-title section-title--action">
          <span>开标一览表</span>
          <template v-if="!editingOpening">
            <el-button v-if="canEdit" type="text" size="small" icon="el-icon-edit" @click="startEditOpening">修改</el-button>
          </template>
          <template v-else>
            <span>
              <el-button type="primary" size="mini" @click="saveOpening" :loading="savingOpening">保存</el-button>
              <el-button size="mini" @click="cancelEditOpening">取消</el-button>
            </span>
          </template>
        </div>
        <!-- 双信封Tab切换 -->
        <div v-if="isDoubleEnvelope" class="envelope-tabs">
          <span class="envelope-tab" :class="{ active: openingEnvelopeTab === '1' }" @click="switchOpeningTab('1')">一信封</span>
          <span class="envelope-tab" :class="{ active: openingEnvelopeTab === '2' }" @click="switchOpeningTab('2')">二信封</span>
        </div>
        <el-table :data="editingOpening ? editOpeningList : currentOpeningList" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="项目名称" min-width="150">
            <template slot-scope="scope">
              <el-input v-if="editingOpening" v-model="scope.row.itemName" size="small" placeholder="项目名称" />
              <span v-else>{{ scope.row.itemName || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="填报内容类型" width="140" align="center">
            <template slot-scope="scope">
              <el-select v-if="editingOpening" v-model="scope.row.itemValueType" size="small" style="width:100%">
                <el-option label="任意文本" :value="0" />
                <el-option label="纯数字" :value="1" />
              </el-select>
              <span v-else>{{ getItemValueTypeText(scope.row.itemValueType) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="100" align="center">
            <template slot-scope="scope">
              <el-select v-if="editingOpening" v-model="scope.row.itemUnit" size="small" style="width:100%">
                <el-option label="元" :value="0" />
                <el-option label="万元" :value="1" />
                <el-option label="%" :value="2" />
              </el-select>
              <span v-else>{{ getItemUnitText(scope.row.itemUnit) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="填报说明" min-width="200">
            <template slot-scope="scope">
              <el-input v-if="editingOpening" v-model="scope.row.itemInstructions" size="small" placeholder="填报说明" />
              <span v-else>{{ scope.row.itemInstructions || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="!editingOpening" label="创建时间" prop="createTime" width="180"></el-table-column>
          <el-table-column v-if="editingOpening" label="操作" width="110" align="center">
            <template slot-scope="scope">
              <!-- 眼睛图标：仅总价行显示 -->
              <el-tooltip v-if="scope.row.itemType === '1'" :content="scope.row.hide === 1 ? '已隐藏' : '已开启'" placement="top">
                <el-button type="text" size="small" @click="togglehide(scope.$index)">
                  <i class="el-icon-view" :style="{ opacity: scope.row.hide === 1 ? 0.3 : 1 }"></i>
                </el-button>
              </el-tooltip>
              <el-button type="text" size="small" style="color:#f56c6c" @click="editOpeningList.splice(scope.$index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-if="editingOpening" type="primary" size="mini" icon="el-icon-plus" @click="addOpeningRow" style="margin-top:10px;">添加行</el-button>
      </div>

      <!-- 目录结构 -->
      <div class="section-block" v-if="catalogueTreeEnvelope1.length > 0 || catalogueTreeEnvelope2.length > 0">
        <div class="section-title section-title--action">
          <span>文件目录</span>
          <template v-if="!editingCatalogue">
            <el-button v-if="canEdit" type="text" size="small" icon="el-icon-edit" @click="startEditCatalogue">修改</el-button>
          </template>
          <template v-else>
            <span>
              <el-button type="primary" size="mini" @click="saveCatalogue" :loading="savingCatalogue">保存</el-button>
              <el-button size="mini" @click="cancelEditCatalogue">取消</el-button>
            </span>
          </template>
        </div>
        <!-- 双信封Tab切换 -->
        <div v-if="isDoubleEnvelope" class="envelope-tabs">
          <span class="envelope-tab" :class="{ active: catalogueEnvelopeTab === '1' }" @click="switchCatalogueTab('1')">一信封</span>
          <span class="envelope-tab" :class="{ active: catalogueEnvelopeTab === '2' }" @click="switchCatalogueTab('2')">二信封</span>
        </div>
        <!-- 编辑模式：树形编辑 -->
        <template v-if="editingCatalogue">
          <div class="catalogue-edit-toolbar">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addRootNode">添加根目录</el-button>
          </div>
          <div class="catalogue-edit-tree">
            <div v-if="editCatalogueTree.length === 0" class="empty-directory">
              <i class="el-icon-folder-opened"></i>
              <p>暂无目录，请添加</p>
            </div>
            <div v-else class="directory-list">
              <div v-for="(item, index) in editCatalogueTree" :key="item.strId" class="directory-item">
                <div class="directory-node">
                  <i class="el-icon-folder"></i>
                  <el-input v-model="item.catalogueName" size="small" placeholder="目录名称" />
                  <div class="directory-actions">
                    <el-button type="text" size="small" icon="el-icon-plus" @click="addChildNode(item)"></el-button>
                    <el-button type="text" size="small" icon="el-icon-delete" @click="removeTreeNode(editCatalogueTree, index)"></el-button>
                  </div>
                </div>
                <div v-if="item.children && item.children.length > 0" class="directory-children">
                  <div v-for="(child, childIndex) in item.children" :key="child.strId" class="directory-item child-item">
                    <div class="directory-node">
                      <i class="el-icon-folder"></i>
                      <el-input v-model="child.catalogueName" size="small" placeholder="目录名称" />
                      <div class="directory-actions">
                        <el-button type="text" size="small" icon="el-icon-plus" @click="addChildNode(child)"></el-button>
                        <el-button type="text" size="small" icon="el-icon-delete" @click="removeTreeNode(item.children, childIndex)"></el-button>
                      </div>
                    </div>
                    <div v-if="child.children && child.children.length > 0" class="directory-children">
                      <div v-for="(grandchild, gcIndex) in child.children" :key="grandchild.strId" class="directory-item grandchild-item">
                        <div class="directory-node">
                          <i class="el-icon-folder"></i>
                          <el-input v-model="grandchild.catalogueName" size="small" placeholder="目录名称" />
                          <div class="directory-actions">
                            <el-button type="text" size="small" icon="el-icon-delete" @click="removeTreeNode(child.children, gcIndex)"></el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 查看模式：树形展示 -->
        <template v-else>
          <el-tree :data="currentCatalogueTree" :props="treeProps" node-key="strId" default-expand-all
            class="catalogue-tree">
            <span class="custom-tree-node" slot-scope="{ data }">
              <span>
                <i class="el-icon-folder-opened" style="color: #409EFF; margin-right: 5px;"></i>
                {{ data.catalogueName }}
              </span>
              <span style="color: #999; font-size: 12px; margin-left: 10px;">
                {{ data.catalogueDescription }}
              </span>
            </span>
          </el-tree>
        </template>
      </div>
    </div>

    <el-dialog title="消息确认" :visible.sync="dialogs.addOpeningType" width="500px" :close-on-click-modal="false"
      :append-to-body="true" class="add-dialog">
      <div class="dialog-content">
        <div class="dialog-title">*添加自定义内容的类型:</div>
        <el-radio-group v-model="addOpeningTypeDialogData.selectedType" class="type-radio-group">
          <div class="radio-row">
            <el-radio label="总价">总价</el-radio><el-radio label="费率">费率</el-radio><el-radio label="单价">单价</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="证书编号">证书编号</el-radio><el-radio label="交货地点">交货地点</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="期限(服务/交货/工期)">期限(服务/交货/工期)</el-radio><el-radio label="其它">其它</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="姓名">姓名</el-radio><el-radio label="质量标准">质量标准</el-radio>
          </div>
        </el-radio-group>
        <div v-if="!addOpeningTypeDialogData.selectedType" class="error-message">请选择自定义内容的类型</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmAddOpeningRow">确认</el-button>
        <el-button @click="cancelAddOpeningRow">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBidInvitationDocumentsDetail, updateBidOpeningListAndCatalogue } from '@/api/modules/agent'
import { getFileList } from '@/api/modules/base'

export default {
  name: 'DetailUploadFile',
  data() {
    return {
      bidInvitationDocumentsCode: '',
      detailData: {},
      fileList: [],
      treeProps: { children: 'children', label: 'catalogueName' },
      editingOpening: false,
      savingOpening: false,
      editOpeningList: [],
      editingCatalogue: false,
      savingCatalogue: false,
      editCatalogueTree: [],
      openingEnvelopeTab: '1',
      catalogueEnvelopeTab: '1',
      openingListEnvelope1: [],
      openingListEnvelope2: [],
      catalogueTreeEnvelope1: [],
      catalogueTreeEnvelope2: [],
      editOpeningE1: [],
      editOpeningE2: [],
      editCatalogueE1: [],
      editCatalogueE2: [],
      dialogs: { addOpeningType: false },
      addOpeningTypeDialogData: { selectedType: '' },
      openingTypeConfig: {
        '总价': { valueType: 1, unit: 0 },
        '费率': { valueType: 1, unit: 2 },
        '单价': { valueType: 1, unit: 0 },
        '证书编号': { valueType: 0, unit: 0 },
        '交货地点': { valueType: 0, unit: 0 },
        '期限(服务/交货/工期)': { valueType: 0, unit: 0 },
        '其它': { valueType: 0, unit: 0 },
        '姓名': { valueType: 0, unit: 0 },
        '质量标准': { valueType: 0, unit: 0 }
      },
      openingItemTypeMap: {
        '总价': '1', '费率': '2', '单价': '3',
        '证书编号': '4', '交货地点': '5', '期限(服务/交货/工期)': '6',
        '姓名': '7', '质量标准': '11', '其它': '0', '单价(大写)': '0'
      }
    }
  },
  computed: {
    mainFileList() { return this.fileList.filter(f => f.fileType === 'invitation-main') },
    attFileList() { return this.fileList.filter(f => f.fileType === 'invitation-att') },
    canEdit() { return true },
    isDoubleEnvelope() { return this.openingListEnvelope2.length > 0 || this.catalogueTreeEnvelope2.length > 0 },
    currentOpeningList() {
      return (this.isDoubleEnvelope && this.openingEnvelopeTab === '2') ? this.openingListEnvelope2 : this.openingListEnvelope1
    },
    currentCatalogueTree() {
      return (this.isDoubleEnvelope && this.catalogueEnvelopeTab === '2') ? this.catalogueTreeEnvelope2 : this.catalogueTreeEnvelope1
    }
  },
  mounted() { this.initPage() },
  methods: {
    initPage() {
      this.bidInvitationDocumentsCode = this.$route.query.bidInvitationDocumentsCode
      if (!this.bidInvitationDocumentsCode) { this.$message.error('缺少招标文件编号参数'); this.$router.go(-1); return }
      this.getBidInvitationDocumentsDetail()
    },
    async getBidInvitationDocumentsDetail() {
      try {
        const res = await getBidInvitationDocumentsDetail({ bidInvitationDocumentsCode: this.bidInvitationDocumentsCode })
        if (res.code === 200) {
          this.detailData = res.data || {}
          this.detailData.bidSectionName = res.data.bidSectionList[0].bidSectionName
          const lists = res.data.bidOpeningLists || []
          this.openingListEnvelope1 = lists.filter(item => !item.envelopeType || Number(item.envelopeType) === 1)
          this.openingListEnvelope2 = lists.filter(item => Number(item.envelopeType) === 2)
          const catalogues = res.data.catalogues || []
          this.catalogueTreeEnvelope1 = catalogues.filter(item => !item.envelopeType || Number(item.envelopeType) === 1)
          this.catalogueTreeEnvelope2 = catalogues.filter(item => Number(item.envelopeType) === 2)
          this.getFileList(res.data.fileGuid)
        } else { this.$message.error(res.msg || '获取招标文件详情失败') }
      } catch (e) { this.$message.error('获取招标文件详情失败') }
    },
    async getFileList(fileGuid) {
      if (!fileGuid) return
      try { const res = await getFileList(fileGuid); if (res.code === 200) { this.fileList = res.data || [] } } catch (e) {}
    },
    formatFileSize(size) {
      if (!size || size === 0) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB', 'TB']; let i = 0; let s = size
      while (s >= 1024 && i < units.length - 1) { s /= 1024; i++ }
      return s.toFixed(i === 0 ? 0 : 2) + ' ' + units[i]
    },
    handleDownloadFile(fileInfo) {
      if (!fileInfo.fileUrl) { this.$message.error('文件下载地址不存在'); return }
      try {
        const a = document.createElement('a'); a.href = fileInfo.fileUrl; a.download = fileInfo.fileName || '文件'
        a.style.display = 'none'; document.body.appendChild(a); a.click(); document.body.removeChild(a)
      } catch (e) { this.$message.error('下载失败') }
    },
    getDocumentTypeText(t) { const m = { 1: '文件', 2: '补遗书', 3: '澄清文件' }; return m[t] || '-' },
    getDocumentStatusText(s) { const m = { 0: '未编制', 1: '已编制' }; return m[s] || '-' },
    getItemValueTypeText(v) { const m = { 0: '任意文本', 1: '纯数字' }; return m[v] || '-' },
    getItemUnitText(u) { const m = { 0: '元', 1: '万元', 2: '%' }; return m[u] || '-' },
    handleBack() { this.$router.go(-1) },

    switchOpeningTab(tab) {
      if (tab === this.openingEnvelopeTab) return
      if (this.editingOpening) { this.saveOpeningSnapshot() }
      this.openingEnvelopeTab = tab
      if (this.editingOpening) { this.loadOpeningSnapshot() }
    },
    saveOpeningSnapshot() {
      const list = JSON.parse(JSON.stringify(this.editOpeningList))
      if (this.openingEnvelopeTab === '1') { this.editOpeningE1 = list } else { this.editOpeningE2 = list }
    },
    loadOpeningSnapshot() {
      const src = this.openingEnvelopeTab === '1' ? this.editOpeningE1 : this.editOpeningE2
      this.editOpeningList = JSON.parse(JSON.stringify(src.length ? src : this.currentOpeningList))
    },
    startEditOpening() {
      if (this.isDoubleEnvelope) {
        this.editOpeningE1 = JSON.parse(JSON.stringify(this.openingListEnvelope1))
        this.editOpeningE2 = JSON.parse(JSON.stringify(this.openingListEnvelope2))
      }
      this.editOpeningList = JSON.parse(JSON.stringify(this.currentOpeningList))
      this.editingOpening = true
    },
    cancelEditOpening() {
      this.editingOpening = false; this.editOpeningList = []
      this.editOpeningE1 = []; this.editOpeningE2 = []; this.openingEnvelopeTab = '1'
    },
    addOpeningRow() { this.addOpeningTypeDialogData.selectedType = ''; this.dialogs.addOpeningType = true },
    confirmAddOpeningRow() {
      if (!this.addOpeningTypeDialogData.selectedType) { this.$message.error('请选择自定义内容的类型'); return }
      const t = this.addOpeningTypeDialogData.selectedType; const cfg = this.openingTypeConfig[t]
      this.editOpeningList.push({ itemName: t, itemValueType: cfg.valueType, itemUnit: cfg.unit, itemInstructions: '', itemType: this.openingItemTypeMap[t] || '0', itemKey: null, hide: 0 })
      if (t === '单价') { this.editOpeningList.push({ itemName: '单价(大写)', itemValueType: 0, itemUnit: 0, itemInstructions: '', itemType: '0', itemKey: null, hide: 0 }) }
      this.dialogs.addOpeningType = false; this.addOpeningTypeDialogData.selectedType = ''
    },
    cancelAddOpeningRow() { this.dialogs.addOpeningType = false; this.addOpeningTypeDialogData.selectedType = '' },

    // 切换总价隐藏状态（眼睛图标）
    togglehide(index) {
      console.log('------',index);
      
     
      const data = this.editOpeningList
      if (data[index].itemType !== '1') return
      const newhide = data[index].hide === 1 ? 0 : 1
      data[index].hide = newhide
      // 总价大写行自动同步
      const totalCapitalRow = data.find(item => item.itemName === '总价(大写)')
      if (totalCapitalRow) {
        totalCapitalRow.hide = newhide
      }
    },
    async saveOpening() {
      this.savingOpening = true
      try {
        this.saveOpeningSnapshot()
        const build = (list, env) => list.map(function (item, index) {
          var r = { itemName: item.itemName || '', itemValueType: item.itemValueType != null ? item.itemValueType : 0, itemUnit: item.itemUnit, itemInstructions: item.itemInstructions || '', itemType: item.itemType != null ? item.itemType : '0', itemKey: item.itemKey != null ? item.itemKey : (index + 1), id: item.id, hide: item.hide || 0 }
          if (env != null) r.envelopeType = env
          return r
        })
        var lists = this.isDoubleEnvelope ? [...build(this.editOpeningE1, 1), ...build(this.editOpeningE2, 2)] : build(this.editOpeningList, null)
        const res = await updateBidOpeningListAndCatalogue({ bidInvitationDocumentsCode: this.bidInvitationDocumentsCode, projectCode: this.detailData.projectCode || this.$route.query.projectCode, bidOpeningLists: lists })
        if (res.code === 200) { this.$message.success('保存成功'); this.editingOpening = false; this.openingEnvelopeTab = '1'; this.editOpeningE1 = []; this.editOpeningE2 = []; await this.getBidInvitationDocumentsDetail() }
        else { this.$message.error(res.msg || '保存失败') }
      } catch (e) { this.$message.error('保存失败') } finally { this.savingOpening = false }
    },

    switchCatalogueTab(tab) {
      if (tab === this.catalogueEnvelopeTab) return
      if (this.editingCatalogue) { this.saveCatalogueSnapshot() }
      this.catalogueEnvelopeTab = tab
      if (this.editingCatalogue) { this.loadCatalogueSnapshot() }
    },
    saveCatalogueSnapshot() {
      const tree = JSON.parse(JSON.stringify(this.editCatalogueTree))
      if (this.catalogueEnvelopeTab === '1') { this.editCatalogueE1 = tree } else { this.editCatalogueE2 = tree }
    },
    loadCatalogueSnapshot() {
      const src = this.catalogueEnvelopeTab === '1' ? this.editCatalogueE1 : this.editCatalogueE2
      this.editCatalogueTree = JSON.parse(JSON.stringify(src.length ? src : this.currentCatalogueTree))
    },
    generateStrId() { return 'n' + Date.now() + '_' + Math.random().toString(36).substr(2, 6) },
    createNewNode(parent) {
      return { strId: this.generateStrId(), catalogueName: '', catalogueDescription: '', catalogueCode: null, catalogueParentCode: parent ? (parent.catalogueCode || 0) : 0, catalogueOrder: 0, isBlindReview: parent ? (parent.isBlindReview != null ? parent.isBlindReview : 0) : 0, bidSectionCode: parent ? (parent.bidSectionCode || '') : '', children: [] }
    },
    startEditCatalogue() {
      if (this.isDoubleEnvelope) { this.editCatalogueE1 = JSON.parse(JSON.stringify(this.catalogueTreeEnvelope1)); this.editCatalogueE2 = JSON.parse(JSON.stringify(this.catalogueTreeEnvelope2)) }
      this.editCatalogueTree = JSON.parse(JSON.stringify(this.currentCatalogueTree))
      this.editingCatalogue = true
    },
    cancelEditCatalogue() { this.editingCatalogue = false; this.editCatalogueTree = []; this.editCatalogueE1 = []; this.editCatalogueE2 = []; this.catalogueEnvelopeTab = '1' },
    addRootNode() { this.editCatalogueTree.push(this.createNewNode(null)) },
    addChildNode(node) { if (!node.children) { this.$set(node, 'children', []) } node.children.push(this.createNewNode(node)) },
    removeTreeNode(parentArr, index) { parentArr.splice(index, 1) },
    processCatalogueTree(tree, parentCode) {
      if (!Array.isArray(tree)) return []
      var autoCode = 9000000
      function build(nodes, pCode) {
        if (!Array.isArray(nodes)) return []
        return nodes.map(function (node, index) {
          var cc = (node.catalogueCode != null && node.catalogueCode !== 0) ? node.catalogueCode : (autoCode++)
          var p = { catalogueCode: cc, catalogueName: node.catalogueName || '', catalogueDescription: node.catalogueDescription || '', catalogueOrder: typeof node.catalogueOrder === 'number' ? node.catalogueOrder : (index + 1), catalogueParentCode: pCode, isBlindReview: node.isBlindReview != null ? node.isBlindReview : 0, bidSectionCode: node.bidSectionCode || '', strId: node.strId, id: node.id }
          p.children = build(node.children || [], cc); return p
        })
      }
      return build(tree, parentCode != null ? parentCode : 0)
    },
    async saveCatalogue() {
      this.savingCatalogue = true
      try {
        this.saveCatalogueSnapshot()
        var catalogues
        if (this.isDoubleEnvelope) {
          var t1 = this.processCatalogueTree(this.editCatalogueE1, 0); var t2 = this.processCatalogueTree(this.editCatalogueE2, 0)
          function mark(nodes, env) { if (!Array.isArray(nodes)) return []; return nodes.map(function (node) { node.envelopeType = env; if (node.children && node.children.length > 0) { node.children = mark(node.children, env) } return node }) }
          catalogues = mark(t1, '1').concat(mark(t2, '2'))
        } else { catalogues = this.processCatalogueTree(this.editCatalogueTree) }
        const res = await updateBidOpeningListAndCatalogue({ bidInvitationDocumentsCode: this.bidInvitationDocumentsCode, projectCode: this.detailData.projectCode || this.$route.query.projectCode, catalogues: catalogues })
        if (res.code === 200) { this.$message.success('保存成功'); this.editingCatalogue = false; this.catalogueEnvelopeTab = '1'; this.editCatalogueE1 = []; this.editCatalogueE2 = []; await this.getBidInvitationDocumentsDetail() }
        else { this.$message.error(res.msg || '保存失败') }
      } catch (e) { this.$message.error('保存失败') } finally { this.savingCatalogue = false }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';
.content-wrap { width: 100%; background-color: #fff; padding: 20px; margin-top: 20px; max-height: calc(100vh - 180px); overflow-y: auto; }
.section-block { margin-bottom: 30px; padding: 20px; background: #fafafa; border-radius: 4px; }
.section-block:last-child { margin-bottom: 0; }
.section-title { font-size: 16px; font-weight: bold; color: #333; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 2px solid #f0f4f7; }
.section-title--action { display: flex; align-items: center; justify-content: space-between; }
.detail-row .field { display: flex; padding: 12px 0; line-height: 1.6; }
.detail-row .field .label { min-width: 180px; color: #666; font-weight: 500; }
.detail-row .field .value { flex: 1; color: #333; word-break: break-all; }
.catalogue-tree { background: #fff; padding: 15px; border-radius: 4px; border: 1px solid #EBEEF5; }
.catalogue-tree .custom-tree-node { flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px; }
::v-deep .el-table { margin-top: 10px; }
::v-deep .el-table th { background-color: #f5f7fa; color: #333; font-weight: 600; }
::v-deep .el-tree-node__content { height: 36px; line-height: 36px; }
.envelope-tabs { display: flex; gap: 0; margin-bottom: 10px; }
.envelope-tab { display: inline-block; padding: 8px 24px; cursor: pointer; border: 1px solid #dcdfe6; background: #fafafa; color: #606266; font-size: 14px; font-weight: 500; transition: all 0.2s ease; user-select: none; }
.envelope-tab:first-child { border-radius: 4px 0 0 4px; }
.envelope-tab:last-child { border-radius: 0 4px 4px 0; border-left: none; }
.envelope-tab:hover { color: #409EFF; background: #ecf5ff; border-color: #409EFF; }
.envelope-tab.active { color: #fff; background: #409EFF; border-color: #409EFF; }
.catalogue-edit-toolbar { margin-bottom: 12px; }
.catalogue-edit-tree { min-height: 200px; max-height: 500px; overflow-y: auto; border: 1px solid #EBEEF5; border-radius: 4px; padding: 12px; background-color: #fafafa; }
.empty-directory { text-align: center; padding: 60px 20px; color: #999; }
.empty-directory i { font-size: 48px; color: #ccc; margin-bottom: 15px; display: block; }
.empty-directory p { font-size: 14px; margin: 0; }
.directory-list .directory-item { margin-bottom: 8px; }
.directory-list .directory-item.child-item { margin-left: 30px; margin-top: 8px; }
.directory-list .directory-item.grandchild-item { margin-left: 30px; margin-top: 8px; }
.directory-list .directory-node { display: flex; align-items: center; padding: 8px 12px; background-color: #fff; border: 1px solid #dcdfe6; border-radius: 4px; transition: all 0.2s ease; gap: 8px; }
.directory-list .directory-node:hover { background-color: #f5f7fa; border-color: #c0c4cc; }
.directory-list .directory-node > i { color: #409EFF; font-size: 16px; flex-shrink: 0; }
.directory-list .el-input { flex: 1; }
.directory-list .directory-actions { display: flex; align-items: center; flex-shrink: 0; margin-left: auto; }
.directory-list .directory-actions .el-button { padding: 0; margin-left: 8px; color: #606266; }
.directory-list .directory-actions .el-button:hover { color: #409EFF; }
.directory-list .directory-children { margin-top: 8px; }
.add-dialog /deep/ .el-dialog__header { padding: 16px 20px; border-bottom: 1px solid #EBEEF5; background: #fafafa; }
.add-dialog /deep/ .el-dialog__title { font-size: 16px; font-weight: 600; color: #333; }
.add-dialog /deep/ .el-dialog__close { font-size: 18px; color: #999; }
.add-dialog /deep/ .el-dialog__close:hover { color: #333; }
.add-dialog /deep/ .el-dialog__body { padding: 20px; }
.add-dialog /deep/ .el-dialog__footer { padding: 15px 20px 20px; text-align: center; border-top: 1px solid #EBEEF5; }
.dialog-content .dialog-title { font-size: 14px; color: #333; margin-bottom: 20px; font-weight: 500; }
.dialog-content .type-radio-group .radio-row { display: flex; margin-bottom: 15px; }
.dialog-content .type-radio-group .radio-row .el-radio { margin-right: 30px; margin-bottom: 0; }
.dialog-content .type-radio-group .radio-row .el-radio__label { font-size: 14px; color: #666; }
.dialog-content .error-message { color: #F56C6C; font-size: 12px; margin-top: 10px; }
.dialog-footer .el-button { padding: 10px 25px; font-size: 14px; }
</style>
